import React from 'react';

// Hooks
import { useNavigate } from 'react-router-dom';

// MUI Components
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

// Icons
import { DetailsCrossCIcon, WarningCIcon } from '~/assets/images';

// Styles
import './styles.scss';
import OlcButton from '~/components/General/OlcButton';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const LimitModal = ({ open, onClose, message, resourceType = 'resource', header = '' }) => {
  const navigate = useNavigate();

  const handleViewPlans = () => {
    onClose();
    navigate('/account/plan');
  };

  // Use API message if provided, otherwise use default message
  const displayMessage =
    message ||
    'This feature is not included in your current plan. Upgrade your plan to access this functionality.';

  // Check if message is a React element (from components like CreateModal)
  const isReactElement = React.isValidElement(displayMessage);

  // Check if message contains HTML tags
  const isHtmlString =
    typeof displayMessage === 'string' && /<\/?[a-z][\s\S]*>/i.test(displayMessage);

  return (
    <>
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={open}
        className="genericConfirmModal limitReachModal"
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 20,
            top: 20,
            padding: '0',
            zIndex: 1000,
            color: (theme) => theme.palette.grey[500],
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: 'transparent',
              opacity: 0.4,
            },
          }}
        >
          <img src={DetailsCrossCIcon} alt="icon" style={{ width: '14px', height: '14px' }} />
        </IconButton>
        <DialogContent className="modalContent">
          <Box className="modalHeader">
            <Typography gutterBottom variant="h4">
              {header && header.length ? header : 'Limit Reached'}
            </Typography>
          </Box>
          <Box className="modalMessage">
            {isReactElement ? (
              displayMessage
            ) : isHtmlString ? (
              <Typography dangerouslySetInnerHTML={{ __html: displayMessage }} />
            ) : (
              <Typography>{displayMessage}</Typography>
            )}
          </Box>
          <Box className="modalBtns">
            <OlcButton variant="secondary" onClick={onClose}>
              Cancel
            </OlcButton>
            <OlcButton variant="primary" onClick={handleViewPlans}>
              View Plans
            </OlcButton>
          </Box>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};

export default LimitModal;
